/**
 * 공고 브리프 — 상세에 싣는 **우리 문장**.
 *
 * 화면의 다른 값은 전부 원문에서 뽑아 대조를 통과한 것이고, 이것만 산문이다.
 * 그래서 계약이 빡빡하다 — focus 없이는 저장하지 않고, 600자를 넘으면 버린다.
 * 설계는 docs/superpowers/specs/2026-09-28-grant-brief-design.md.
 */
/** 브리프가 무엇을 잡는가. 모델이 고르고 우리가 저장한다 — 집계와 회귀 비교용이다. */
export const BRIEF_FOCUSES = [
    'amount', // 얼마를 받고 자기부담이 얼마인가
    'benefits', // 돈이 아닌 무엇을 받나 — 프로그램·교육·판로
    'eligibility', // 누가 되고 무엇에 걸리나
    'occupancy', // 입주 조건과 실제로 드는 비용
    'financing', // 금리·상환·보증 조건
    'competition', // 총액과 정원 — 한 곳당 몫
];
/** 상한 600자. 3~6문장이다 — 실측으로 쓸 만한 브리프가 258자였다. */
export const BRIEF_MAX_CHARS = 600;
/**
 * 브리프와 focus 를 **함께** 받아들이거나 **함께** 버린다.
 *
 * 한쪽만 저장하면 둘 다 쓸모가 없다 — focus 없는 브리프는 집계가 안 되고,
 * 브리프 없는 focus 는 가리킬 대상이 없다.
 */
export function normalizeBrief(brief, focus) {
    /*
      **타입까지 여기서 본다.** 봉투는 `z.unknown()` 으로 열려 있다 — 모양을 봉투가
      따지면 브리프 하나 때문에 rows 와 eligibility 가 422 로 같이 죽고, 그 422 가
      러너의 차단기를 먹여 backfill 전체를 멈춘다.
    */
    if (typeof brief !== 'string' || (focus !== null && focus !== undefined && typeof focus !== 'string')) {
        return null;
    }
    const text = brief.trim();
    if (!text)
        return null;
    if (text.length > BRIEF_MAX_CHARS)
        return null;
    if (!focus || !BRIEF_FOCUSES.includes(focus))
        return null;
    return { brief: text, focus: focus };
}
//# sourceMappingURL=grant-brief.js.map